export default "__VITE_ASSET__C_Cqw00e__"